export default "/images/framework/Loginimg.ca194808.svg?ca194808";